import RoleNavigation from "./RoleNavigation";
export default function InmateNav() {
  return <RoleNavigation role="inmate" />;
}
